var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "#logo",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 63 63",
      },
    },
    [
      _c("path", {
        staticClass: "fill-white",
        attrs: {
          d: "M31.5,0A31.5,31.5,0,1,0,63,31.5,31.5,31.5,0,0,0,31.5,0ZM20.69,46.61H12.77V21.14h7.92ZM16.68,18a4,4,0,1,1,.1-7.92,4,4,0,1,1-.1,7.92ZM52.35,46.61H44.44V32.49c0-3.28-1.15-5.52-4-5.52a4.35,4.35,0,0,0-4.06,3,5.72,5.72,0,0,0-.26,2V46.61H28.19V29.26c0-3.18-.1-5.83-.21-8.12h6.87l.36,3.54h.16a9.15,9.15,0,0,1,7.86-4.11c5.21,0,9.11,3.49,9.11,11Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }